import React from 'react'
import './Radio.sass'

const Radio = (props) => {

	return (
		<div className={props.className ? props.className + " no__radio-group" : "no__radio-group"}>
			{props.title && <strong>{props.title}</strong>}
			{props.options.map((option, index) => (
				<div className="radio__group" key={index}>
					<input
						type={props.type ? props.type : "radio"}
						name={props.name}
						id={`${props.name}_${index}`}
						onChange={props.handleChange}
						required={props.required}
						value={option.value}
						checked={props.selected + '' === option.value + ''}
					/>
					{props.html ?
						<label htmlFor={`${props.name}_${index}`} dangerouslySetInnerHTML={{__html: option.label}}></label>
					 :
						<label htmlFor={`${props.name}_${index}`}>{option.label}{props.required && '*'}</label>}
					
				</div>
			))}			
		</div>
	)
}

export default Radio
